import { render, staticRenderFns } from "./Trial00.vue?vue&type=template&id=2f40a71a&scoped=true&"
import script from "./Trial00.vue?vue&type=script&lang=js&"
export * from "./Trial00.vue?vue&type=script&lang=js&"
import style0 from "./Trial00.vue?vue&type=style&index=0&id=2f40a71a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40a71a",
  null
  
)

export default component.exports